import React from 'react';

const LOGO_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/wingman/ff1ac768-2fd7-43bf-8ad4-7e8fb9fb1144/attachments/90bfb53e790f41f495c6af59502ad198_Future%20Ready%20%282000%20x%201000%20px%29%20%282000%20x%20800%20px%29%20%282200%20x%201000%20px%29%20%281100%20x%20220%20px%29%20%283%29.png";
const FUTURE_READY_URL = "https://futureready.school/";

export function BrandLogo({ className = "", size = "md" }) {
  const heights = { sm: "h-8 sm:h-9", md: "h-10 sm:h-12", lg: "h-12 sm:h-16" };
  const maxW = size === "lg" ? "max-w-[280px]" : size === "sm" ? "max-w-[180px]" : "max-w-[240px] sm:max-w-[280px]";
  return (
    <a
      href={FUTURE_READY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="brand-logo-link"
      className="inline-flex items-center"
    >
      <img
        src={LOGO_URL}
        alt="Future Ready School"
        data-testid="brand-logo"
        className={`${heights[size] || heights.md} w-auto ${maxW} object-contain ${className}`}
      />
    </a>
  );
}

export function BrandBanner({ compact = false }) {
  return (
    <div
      className={`w-full flex items-center justify-center ${compact ? "py-2 sm:py-3" : "py-3 sm:py-4"} bg-white border-b border-[#E2E8F0]`}
      data-testid="brand-banner"
    >
      <BrandLogo size={compact ? "sm" : "md"} />
    </div>
  );
}
